/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disable_NotificationsInputs */

const th_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดบนอุปกรณ์นี้`)
};

const en_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off on this device`)
};

const ja_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この端末でオフにする`)
};

const zh_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在本设备上关闭`)
};

const es_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivar en este dispositivo`)
};

const pt_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligar neste dispositivo`)
};

const id_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matikan di perangkat ini`)
};

const fr_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver sur cet appareil`)
};

const tl_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patayin sa device na ito`)
};

const vi_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt trên thiết bị này`)
};

const ko_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기기에서 끄기`)
};

const de_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Gerät ausschalten`)
};

const ru_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выключить на этом устройстве`)
};

const tr_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu cihazda kapat`)
};

const it_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattiva su questo dispositivo`)
};

const pl_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłącz na tym urządzeniu`)
};

const uk_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вимкнути на цьому пристрої`)
};

const hi_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस उपकरण पर बंद करें`)
};

const ar_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إيقافها على هذا الجهاز`)
};

const ms_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matikan pada peranti ini`)
};

const bn_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই যন্ত্রে বন্ধ করুন`)
};

const zh_tw2_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在這台裝置上關閉`)
};

const zh_hk2_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在這台裝置上關閉`)
};

const ur_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس آلے پر بند کریں`)
};

const fa_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خاموش کردن روی این دستگاه`)
};

const sw_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zima kwenye kifaa hiki`)
};

const nl_disable_notifications = /** @type {(inputs: Disable_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitzetten op dit apparaat`)
};

/**
* | output |
* | --- |
* | "Turn off on this device" |
*
* @param {Disable_NotificationsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const disable_notifications = /** @type {((inputs?: Disable_NotificationsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disable_NotificationsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_disable_notifications(inputs)
	if (locale === "ja") return ja_disable_notifications(inputs)
	if (locale === "zh") return zh_disable_notifications(inputs)
	if (locale === "es") return es_disable_notifications(inputs)
	if (locale === "pt") return pt_disable_notifications(inputs)
	if (locale === "id") return id_disable_notifications(inputs)
	if (locale === "fr") return fr_disable_notifications(inputs)
	if (locale === "tl") return tl_disable_notifications(inputs)
	if (locale === "vi") return vi_disable_notifications(inputs)
	if (locale === "ko") return ko_disable_notifications(inputs)
	if (locale === "de") return de_disable_notifications(inputs)
	if (locale === "ru") return ru_disable_notifications(inputs)
	if (locale === "tr") return tr_disable_notifications(inputs)
	if (locale === "it") return it_disable_notifications(inputs)
	if (locale === "pl") return pl_disable_notifications(inputs)
	if (locale === "uk") return uk_disable_notifications(inputs)
	if (locale === "hi") return hi_disable_notifications(inputs)
	if (locale === "ar") return ar_disable_notifications(inputs)
	if (locale === "ms") return ms_disable_notifications(inputs)
	if (locale === "bn") return bn_disable_notifications(inputs)
	if (locale === "zh-TW") return zh_tw2_disable_notifications(inputs)
	if (locale === "zh-HK") return zh_hk2_disable_notifications(inputs)
	if (locale === "ur") return ur_disable_notifications(inputs)
	if (locale === "fa") return fa_disable_notifications(inputs)
	if (locale === "sw") return sw_disable_notifications(inputs)
	if (locale === "nl") return nl_disable_notifications(inputs)
	return en_disable_notifications(inputs)
});